import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/ar-sa";
import "dayjs/locale/he";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import "dayjs/locale/he";
import i18n from "../i18n";

export default function CustomDatePicker({ onDateChange }) {
  const [selectedDate, setSelectedDate] = React.useState(null);
  const { t } = useTranslation();
  const disableTueSatWithCutoff = (date) => {
    const d = dayjs(date).startOf('day');
    const now = dayjs(); // Don't start of day here, we need the current time
    const weekday = d.day();
    const cutOffHour = 14;

    // Block past dates
    if (d.isBefore(now, 'day')) return true;

    // Only allow Tuesday (2) or Saturday (6)
    if (weekday !== 2 && weekday !== 6) return true;

    // Compute this week's Monday and Friday cutoff times
    const thisWeekMonday = now.startOf('week').add(1, 'day');
    const thisWeekFriday = now.startOf('week').add(5, 'day');
    const mondayCutoff = thisWeekMonday.hour(cutOffHour).minute(0).second(0);
    const fridayCutoff = thisWeekFriday.hour(cutOffHour).minute(0).second(0);

    // For Tuesday deliveries
    if (weekday === 2) {
      if (now.isAfter(mondayCutoff) && d.isSame(thisWeekMonday.add(1, 'day'), 'day')) {
        return true;
      }
    }

    // For Saturday deliveries
    if (weekday === 6) {
      if (now.isAfter(fridayCutoff) && d.isSame(thisWeekFriday.add(1, 'day'), 'day')) {
        return true;
      }
    }

    return false;
  };

  const localeMap = {
    ar: "ar-sa",
    he: "he",
    en: "en",
  };

  const currentLocale = localeMap[i18n.language] || "en";

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    if (onDateChange) {
      onDateChange(newValue);
    }
  };

  const preventKeyboardInput = (event) => {
    event.preventDefault();
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={currentLocale}
    >
      <Box display="flex">
        <DatePicker
          label={t("pickDeliveryDateLabel")}
          value={selectedDate}
          onChange={handleDateChange}
          shouldDisableDate={disableTueSatWithCutoff}
          sx={{
            width: "160px",
            mt: 2.5,
            mb: 1.5,
            display: "flex",
            alignContent: "center",
          }}
          closeOnSelect
          slotProps={{
            textField: {
              InputProps: {
                readOnly: true,
              },
              onKeyDown: preventKeyboardInput,
              onPaste: preventKeyboardInput,
            },
            calendarHeader: {
              sx: {
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 2,
                backgroundColor: "#f7f7f7",
                borderBottom: "1px solid #ddd",
                direction: "unset",
              },
            },
            leftArrowIcon: {
              sx: {
                transform: "rotate(180deg)",
              },
            },
            rightArrowIcon: {
              sx: {
                transform: "rotate(180deg)",
              },
            },
            toolbar: {
              hidden: true,
            },
          }}
          format="DD/MM/YYYY"
        />
      </Box>
    </LocalizationProvider>
  );
}
